/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUsDto } from '../../models/user-us-dto';

export interface GetAllUserDetails$Params {
  usid: number;
  orid: number;
}

export function getAllUserDetails(http: HttpClient, rootUrl: string, params: GetAllUserDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserUsDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllUserDetails.PATH, 'get');
  if (params) {
    rb.path('usid', params.usid, {});
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserUsDto>>;
    })
  );
}

getAllUserDetails.PATH = '/api/Auth/getUsersById/{usid}/{orid}';
